export const API_BASE_PATHS = {
  functions: '/.netlify/functions',
  production: '/api',
} as const;

export type ApiBasePath = typeof API_BASE_PATHS[keyof typeof API_BASE_PATHS];

const MEDIA_ROUTE = 'media';
const POSITIVE_INTEGER_ID = /^[1-9]\d*$/;
const apiBasePaths = Object.values(API_BASE_PATHS);

const mediaPathPrefix = (basePath: ApiBasePath): string => `${basePath}/${MEDIA_ROUTE}/`;

export const buildMediaUrl = (basePath: ApiBasePath, photoId: number): string =>
  `${mediaPathPrefix(basePath)}${photoId}`;

export const isMediaUrl = (path: string): boolean => {
  const prefix = apiBasePaths
    .map(mediaPathPrefix)
    .find((candidate) => path.startsWith(candidate));

  return prefix !== undefined && POSITIVE_INTEGER_ID.test(path.slice(prefix.length));
};
